import sendReportRequest from './sendReportRequest';

const fetchReportSalesByArea = async ({ dateRange, from, to, reportingType }) => {
  const reponseData = await sendReportRequest({
    url: '/reports/salesByArea',
    dateRange,
    from,
    to,
    reportingType,
  });

  return reponseData;
};

export default fetchReportSalesByArea;
